import type { Logger, LogLevel } from './types'

/**
 * 创建简单的控制台日志器
 * @param level 最低输出级别
 * @returns 实现 Logger 接口的日志器
 */
export function createLogger(level: LogLevel = 'info'): Logger {
  const levels: LogLevel[] = ['debug', 'info', 'warn', 'error']
  /**
   * 判断指定级别是否允许输出
   */
  const enabled = (l: LogLevel) => levels.indexOf(l) >= levels.indexOf(level)
  return {
    level,
    /** 输出调试日志 */
    debug: (...args: any[]) => { if (enabled('debug')) console.debug('[SDK]', ...args) },
    /** 输出信息日志 */
    info: (...args: any[]) => { if (enabled('info')) console.info('[SDK]', ...args) },
    /** 输出警告日志 */
    warn: (...args: any[]) => { if (enabled('warn')) console.warn('[SDK]', ...args) },
    /** 输出错误日志 */
    error: (...args: any[]) => { if (enabled('error')) console.error('[SDK]', ...args) }
  }
}
